import { Layout } from 'components/GenericLayoutBuilder';

export const defaultSupportFormValue = {
  enabled: false,
};
